import AbstractOptionList from './AbstractOptionList'
import BsCheckbox from './BsCheckbox'

export default {
  functional: true,
  render (h, {data, children}) {
    return h(AbstractOptionList, {...data, props: {...data.props, component: BsCheckbox}}, children)
  }
}
